<template>
  <div class="coin-index">
    <!-- <header-link :link="headerLink"></header-link> -->
    <div class="coin-index-header">
      <!-- 金幣/鑽石管理 -->
      {{ titleText }}
      <!-- 解决 ios 13.5 列表checkbox 显示不全的问题，我也不知道为啥，但是就可以 -->
      <span class="line" />
    </div>
    <div class="coin-main">
      <!-- <router-view></router-view> -->
      <org-account />
    </div>
  </div>
</template>
<script>
import headerLink from './components/headerLink';
import orgAccount from './manage/organization';
export default {
    name: 'CoinIndex',
    components: {
        headerLink,
        orgAccount
    },
    data() {
        return {
            headerLink: [
                {
                    url: '/coin/index',
                    name: '組別賬戶',
                    id: 1,
                    show: true
                }
            ],
            titleText: ''
        };
    },
    created() {
        this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
            // console.log(res,'配置');
            if (res.data.code === 0 && res.data.result) {
                let isUsedCoin = res.data.result.isUsedCoin;
                let isUsedDiamond = res.data.result.isUsedDiamond;
                this.titleText = isUsedCoin && isUsedDiamond ? '金幣/鑽石管理' : isUsedDiamond ? '鑽石管理' : '金幣管理';
            }
        });
    }
};
</script>
<style lang="less" scpoed>
@import '../../assets/css/element-reset.less';
.coin-index {
    text-align: left;
    // height: 100%;
    // padding-left: 20px;
    .coin-index-header {
        padding-bottom: 24px;
        font-size: 24px;
        color: #171725;
        .line {
            display: inline-block;
            width: 1px;
            height: 22px;
            background-color: #979797;
            position: relative;
            top: 3px;
            margin: 0 14px;
            visibility: hidden;
        }
    }
    .coin-main {
        padding-bottom: 20px;
    }
}
</style>
